import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Healthcheck from './Health'

import {
  fetchHealthCheck,
  getHealthCheckError,
  getHealthCheckStatus,
  selectHealthCheck,
} from '../../store/reducers/healthCheckSlice'

import { fetchBulkHealthCheck, selectBulkHealthCheck, getBulkHealthCheckStatus, getBulkHealthCheckError } from '../../store/reducers/bulkHealthCheckSlice'

export function Health() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const healthCheck = useSelector(selectHealthCheck)
  const status = useSelector(getHealthCheckStatus)
  const error = useSelector(getHealthCheckError)
  const [refresh, setRefresh] = useState(false)

  const healthBulkCheck = useSelector(selectBulkHealthCheck)
  const bulkHealthStatus = useSelector(getBulkHealthCheckStatus)
  const bulkHealthError = useSelector(getBulkHealthCheckError)
  const [bulkRefresh, setBulkRefresh] = useState(false)

  useEffect(() => {
    dispatch(fetchHealthCheck())
    dispatch(fetchBulkHealthCheck())
  }, [dispatch])

  const handleRefresh = () => {
    if (!refresh) {
      setRefresh(true)
      dispatch(fetchHealthCheck())
        .then(() => setRefresh(false))
        .catch(() => setRefresh(false))
    }
  }

  const handleBulkRefresh = () => {
    if (!bulkRefresh) {
      setBulkRefresh(true)
      dispatch(fetchBulkHealthCheck())
        .then(() => setBulkRefresh(false))
        .catch(() => setBulkRefresh(false))
    }
  }

  return (
    <div style={{ width: '100vw' }}>
      <Healthcheck
        t={t}
        status={status}
        hasIssues={status !== 'healthy' || healthCheck?.idpStatus !== 'healthy'}
        handleRefresh={handleRefresh}
        healthCheck={healthCheck}
        healthRows={[
          { label: 'health-idp-title', key: 'idp', value: healthCheck?.idpStatus },
          { label: 'health-uptime-title', key: 'uptime', value: Math.round(healthCheck.uptime) },
        ]}
        error={error}
        healthType="general"
      />
      <Healthcheck
        t={t}
        status={bulkHealthStatus}
        handleRefresh={handleBulkRefresh}
        hasIssues={bulkHealthStatus !== 'healthy' || healthBulkCheck?.jobServiceHealth?.status !== 'healthy'}
        healthCheck={healthBulkCheck}
        healthRows={[
          { label: 'health-uptime-title', key: 'uptime', value: Math.round(healthBulkCheck?.uptime) },
          { label: 'health-jobService-title', key: 'jobServiceHealth', value: (healthBulkCheck.jobServiceHealth?.status) },
          { label: 'health-jobService-uptime-title', key: 'jobServiceUptime', value: Math.round(healthBulkCheck?.jobServiceHealth?.uptime) },
        ]}
        error={bulkHealthError}
        healthType="bulk"
      />
    </div>
  )
}

export default Health
